import React from "react"
import "./extra-pages.scss"
import SectionHeader from "../sectionHeader/sectionHeader"
import { Link } from "gatsby"
import AniLink from "gatsby-plugin-transition-link/AniLink"

// import bookIsha from "./asset/book-isha.png"
// import bookSawal from "./asset/book-sawal.png"

// {
//     q: <div className="question"></div>,
//     a: <div className="answer"></div>,
//   },
const faqs = [
  {
    q: <div className="question">What is Wisdom words publishing?</div>,
    a: (
      <div className="answer">
        Wisdom word publishing is a publishing platform for authors. We provide
        them a guiding hand to make their publishing process effortless.
      </div>
    ),
  },
  {
    q: <div className="question">Why to choose Wisdom words publishing?</div>,
    a: (
      <div className="answer">
        Wisdom words publishing is one of the leading publishing houses,
        publishing the quality printed books and e-books in all the genres and
        in all sizes and types. Unlike other self-publishing firms who offer
        essential publishing services, wisdom words in addition to those
        essential publishing services also offer the allied services like,
        managing social media accounts, getting the review for the books etc.
        All this is handled by the team of professionals who are young, skilled,
        hi-tech, dedicated and having several years of relevant industry
        experience. The team constantly strives to make the publishing journey
        smooth and easy for our authors.
      </div>
    ),
  },
  {
    q: <div className="question">What is the publishing process?</div>,
    a: (
      <div className="answer">
        Just handover your hard-worked manuscript and we will give you a
        professional book within a month. It’s that easy. Everything is on us,
        like a fine editing, an eye-catching cover and attractively designed
        interior, with addition to promotion and marketing facility.
      </div>
    ),
  },
  {
    q: (
      <div className="question">
        In which format do you accept the manuscript?
      </div>
    ),
    a: (
      <div className="answer">
        Basically, we prefer manuscripts in Word format. In case, if you have it
        in any other format, we don’t reject that either.
      </div>
    ),
  },
  {
    q: (
      <div className="question">
        If my manuscript has some mistakes like, typing or in sentence making or
        small grammatical issues, will that be taken care of by you before a
        book goes to a print?
      </div>
    ),
    a: (
      <div className="answer">
        For this, we suggest you to opt for one of our editing services.
        Depending upon the editing services chosen, the manuscript is worked
        upon. And then the correction and the changes will be done, once you
        approve them and are happy with the changes.{" "}
      </div>
    ),
  },
  {
    q: (
      <div className="question">How many copies of a book will you print?</div>
    ),
    a: (
      <div className="answer">
        Wisdom words manage inventory services very well. So, be assured about
        your book copies, there is no chance that the book will ever be out of
        stock. And if the first edition of the book is completely sold off, then
        we offer the print on demand facility and the book then goes to digital
        POD. After the stock of the first edition of the books sold off, it’s a
        choice of the author, whether he/she wants to print the second edition
        of the book in a lot, or wants to opt for the POD facility. We have both
        the ways open.{" "}
      </div>
    ),
  },
  {
    q: (
      <div className="question">
        Who owns and retains the rights of the book?
      </div>
    ),
    a: (
      <div className="answer">
        The book is the output of the author’s hardwork and we are just the
        facilitator. Hence there is no doubt about who should hold the rights of
        the book. It will always be you (authors), when it comes to retaining
        the rights of the books.
      </div>
    ),
  },
  {
    q: <div className="question">What is ISBN?</div>,
    a: (
      <div className="answer">
        ISBN stands for International Standard Book Number and it is 13 digits
        unique numerical code assigned to a single book. It gives a book an
        international identity and helps in facilitating sales. ISBN is used in
        the stock control process by booksellers and librarians. A separate ISBN
        is assigned to different editions of a book like Paperback, Hardcover
        and eBook.
      </div>
    ),
  },
  {
    q: <div className="question">What is the procedure to get the ISBN?</div>,
    a: (
      <div className="answer">
        For ISBN, application has to be made to Raja Rammohun Roy National
        Agency for ISBN. And Wisdom words will get it for you. You don’t have to
        panic about it. We undertake the entire process to get the ISBN for our
        author’s book. With that, also make sure to insert the barcode that
        helps the sellers to scan the ISBN.
      </div>
    ),
  },
  {
    q: (
      <div className="question">
        What about the profit distribution, how and when it is distributed?
      </div>
    ),
    a: (
      <div className="answer">
        Profits from the sale of books are distributed at month-end in the
        author’s bank account directly. However, if the author wishes to get the
        amount credited in other sources like in Paytm wallet or Google Pay, we
        are also comfortable with that.
      </div>
    ),
  },
  {
    q: <div className="question">What about the post-publishing support?</div>,
    a: (
      <div className="answer">
        Wisdom words publishing highly believes in nurturing the human relation
        and hence doesn’t end the journey with just delivering the published
        books, but it rather goes beyond it. Our team makes sure that our
        authors never face any issue in after-sales support. Whether it is
        associated with the transparency in sales report or its about 100
        percent royalty payments or it is about addressing the grievances of the
        authors related to the quality of the printed books. Trust us, the
        long-term association is our priority and we take it way too seriously.
      </div>
    ),
  },
  {
    q: (
      <div className="question">
        Will Wisdom Word publishing also create, distribute and promote my
        eBook, along with the physical book?
      </div>
    ),
    a: (
      <div className="answer">
        Yes…we do, create, promote and distribute the eBooks. But they are to be
        taken as an add-on service by the authors. The services are available at
        a minimum charge. The distribution takes place on different platforms
        like Kindle, Google Play and Kobo, etc.
      </div>
    ),
  },
  {
    q: (
      <div className="question">
        Will I be provided with the demo of a website?
      </div>
    ),
    a: (
      <div className="answer">
        Yes. Before the website goes live, we will share it with you. And once
        you are satisfied with it, then only it gets live.{" "}
      </div>
    ),
  },
  {
    q: (
      <div className="question">
        Will the author website be of a single web page or will it be having
        multiple web pages?
      </div>
    ),
    a: (
      <div className="answer">
        Your author website will consist of a multi-page website.
      </div>
    ),
  },
  {
    q: (
      <div className="question">
        Will you be working on the content for the author’s website?
      </div>
    ),
    a: (
      <div className="answer">
        Your author website will hold the list of your book(s), other published
        books, your images, about the book, about the author, reviews, sample
        chapters and extracts etc. However, there will not be any new content
        created.
      </div>
    ),
  },
  {
    q: (
      <div className="question">Will I be provided with the video trailer?</div>
    ),
    a: (
      <div className="answer">
        Yes, it can be provided with extra charges. Charges will depend upon the
        specification you require, like a simple video or animated one. You can
        use it to promote your book on social media pages and websites.
      </div>
    ),
  },
  {
    q: <div className="question">What about the pre-launch buzz?</div>,
    a: (
      <div className="answer">
        As per past experience and observation, the best time to promote the
        book is when the book is listed on the e-commerce site and is available
        for purchase. As a part of the pre-launch buzz, we do promote the event
        on social media.
      </div>
    ),
  },
  {
    q: <div className="question">How will you decide the MRP of the book?</div>,
    a: (
      <div className="answer">
        MRP is ascertained after considering many factors like, printing and
        distribution cost of the book. Besides that, the price of a similar book
        in the same genre with the same page is also considered.{" "}
      </div>
    ),
  },
  {
    q: (
      <div className="question">
        Why is the net receipt received by selling from Wisdom Words publishing
        is more than the other e-commerce platforms?
      </div>
    ),
    a: (
      <div className="answer">
        The net receipt will always be more if your books get sold from our
        portal because other e-commerce websites charge 40% to 50% as the
        distribution fees. Hence the royalty decreases on the other platforms.
      </div>
    ),
  },
  {
    q: <div className="question">What about the guarantee of book sales?</div>,
    a: (
      <div className="answer">
        No one can give that guarantee, but we do guarantee to give our complete
        dedication to make your book reach more and more readers via online and
        offline distribution mode. Then the purchasing decision lies on the
        readers.
      </div>
    ),
  },
  {
    q: (
      <div className="question">
        Is it possible to distribute the book without keeping the prior stock of
        it?
      </div>
    ),
    a: (
      <div className="answer">
        Yes, you may. We have a POD (Print on Demand) facility for that
        reference.
      </div>
    ),
  },
  {
    q: (
      <div className="question">
        I already have my book published and want you to manage the e-commerce
        for me. Will that be possible?
      </div>
    ),
    a: (
      <div className="answer">
        Yes, we can manage it at ease. We will keep your book in our stock, list
        it on various e-commerce portals and will manage the orders accordingly.
        It’s that simple. And the net receipts are paid monthly to the authors
        after deducting the logistic expenses, e-commerce retailer’s charges and
        warehousing expenses.
      </div>
    ),
  },
  {
    q: (
      <div className="question">
        How will I be reported with the sales of my book?
      </div>
    ),
    a: (
      <div className="answer">
        Wisdom words provide a fair monthly sales report to the author.
      </div>
    ),
  },
  {
    q: (
      <div className="question">
        I am worried about the quality of the book, how do I ensure it?
      </div>
    ),
    a: (
      <div className="answer">
        Your concern about quality is completely justified. But you don’t have
        to worry at all about it, because our printing process is so standard.
        We use the printing services of the best printers of India (even the
        renowned traditional publishers like Penguin and Westland, etc, get
        their book printed from them). Still, if this doesn’t clear your
        concerns, we can send you a sample copy of a book published from our
        publishing house.
      </div>
    ),
  },
  {
    q: <div className="question">What is an eBook?</div>,
    a: (
      <div className="answer">
        An eBook or an electronic book is a book whose content is in electronic
        format. Your book can be viewed on laptops, computers e-readers and
        mobile phones etc.
      </div>
    ),
  },
  {
    q: (
      <div className="question">
        Can one ISBN be used for other formats also? Like can I use the ISBN of
        a paperback book for an eBook?
      </div>
    ),
    a: (
      <div className="answer">
        Well..as per ISBN authorities, each book edition or version should have
        different ISBNs. So we recommend to not use the Paperback ISBN for an
        eBook.
      </div>
    ),
  },
  {
    q: (
      <div className="question">
        How will I be able to track the results of my social media pages?
      </div>
    ),
    a: (
      <div className="answer">
        Wisdom words will provide you with the monthly report of all the
        activities done and the performances in regards to your social media
        pages.
      </div>
    ),
  },
  {
    q: (
      <div className="question">
        Will I also be having access to my social media pages you create?
      </div>
    ),
    a: (
      <div className="answer">
        Yes, you will be provided with the admin access to your social media
        page. You can create any new post or can edit the post. You can work on
        your own way over your social media pages, apart from what we do.{" "}
      </div>
    ),
  },
  {
    q: (
      <div className="question">
        Could you please suggest the best social media platforms which can help
        me in establishing myself as an author brand?
      </div>
    ),
    a: (
      <div className="answer">
        Currently, the best social media platforms that can help you in
        establishing the author’s brand are Facebook, Instagram and Twitter.
      </div>
    ),
  },
  {
    q: (
      <div className="question">
        Which all social media platforms are you active on?
      </div>
    ),
    a: (
      <div className="answer">
        Wisdom Words publishing is active on Facebook, Twitter and Instagram.
      </div>
    ),
  },
  {
    q: (
      <div className="question">
        I want my superior author fan page to yield me with good numbers of book
        sales. Could you guarantee that?
      </div>
    ),
    a: (
      <div className="answer">
        We use all of the best organic resources to handle your fan page and
        build the audience. Based on past experiences, our activities have
        resulted in wonderful results. However, there is no direct link between
        the excellent fan page and book sales and hence we can only commit to
        enable your book to more and more readers with our best marketing
        activities. Whether to purchase or not purchase the book is the reader’s
        choice.
      </div>
    ),
  },
  {
    q: (
      <div className="question">
        How will Twitter be used as a marketing service?
      </div>
    ),
    a: (
      <div className="answer">
        We use Twitter for building a fan-base of readers, tweeting about the
        book and about the authors. Besides that, we also use Twitter to
        interact with the fans.
      </div>
    ),
  },
  {
    q: (
      <div className="question">
        How and when I will be reported with the sales report?
      </div>
    ),
    a: (
      <div className="answer">
        The sales report is sent via email at the end of every month.
      </div>
    ),
  },
  {
    q: (
      <div className="question">How and when I will be receiving royalty?</div>
    ),
    a: (
      <div className="answer">
        The royalty is paid in the bank account directly on a quarterly basis.
      </div>
    ),
  },
  {
    q: <div className="question">What kind of proposals do you entertain?</div>,
    a: (
      <div className="answer">
        Wisdom words accept and entertain all the fiction and non-fiction
        writings in English, Hindi and other regional languages.
      </div>
    ),
  },
  {
    q: <div className="question"></div>,
    a: <div className="answer"></div>,
  },
  {
    q: <div className="question"></div>,
    a: <div className="answer"></div>,
  },
  {
    q: <div className="question"></div>,
    a: <div className="answer"></div>,
  },
]

const privPolicy = (
  <div>
    Wisdom Words value privacy and also respect the trust that the author
    showers on us. Hence all the information gathered with us is encrypted using
    a server for the highest security. We have also framed the privacy policy to
    express how we handle our user information. The following privacy policy
    pertains to former and present visitors and online clients. Using our
    website implies that the user agrees to our privacy policy.
    <br />
    <br />
    <b>Personal details : </b>
    We accumulate your personal information like name, email, contact number,
    address, Pincode, IP address etc. We might use your personal details to
    contact you, for marketing and promotional schemes, to respond, for a
    contest, for improving our product and service, customizing the experience,
    to look for site trends and customer insights. Besides these, user personal
    details might also be used in making the products better, introducing a new
    product or offers, transactional communications, sending emails, or SMS. We
    also blend the information received from third parties. All the information
    is solely for security purposes and we use it for protecting our company,
    customer and our website. Wisdom Words publishing uses the information as
    permitted by the law.
    <br />
    <br />
    <b>Payment details : </b>
    We might accumulate your payment method and billing details at the time of
    payment. However, we never accumulate the details of a credit card or debit
    card.
    <br />
    <br />
    <b>The information posted : </b>
    We collect the information posted on a public place, on our website and
    third-party social media site of https://wisdomwords.in/
    <br />
    <br />
    <b>Demographic information : </b>
    We might accumulate users demographic information, like events they like or
    participate in, or any other such information provided during or website
    use. The information collected can be used as a part of a survey.
    <br />
    <br />
    <b>Sharing information with third-parties : </b>
    Wisdom Words publishing may share the information in a good faith with the
    third parties who lend services to us like business partners. Besides this,
    the information may also be shared with the vendors who help us in managing
    the online services like, payment processor and transactional message
    processors. Vendors might be located out of India. Shared information will
    be used by our partners as per described in their privacy policy. The
    information can be shared to comply with the law, for responding to the
    court order or protecting ourselves. Moreover, the information can also be
    shared to investigate potential frauds and with any successor of a business.
    <br />
    Kindly be noted that, if you click the links to third party websites that
    take you to the websites that we don’t control. In such cases, Wisdom Words
    Publishing will not be responsible for their privacy policy. Thus, we advise
    you to read the privacy policy of other websites carefully.
    <br />
    <br />
    <b>Other information : </b>
    By using our website, it implies that we can gather information about user
    IP address and the browser information. We might focus on the details like,
    from which site you came, time spent on our website, page accessed. Other
    than this, we can also gather the information regarding the type of mobile
    device user is using, version of the operating system. We gather information
    in various ways directly and indirectly through phone, email, query form,
    comments posted. Wisdom words also gather the information via Google
    Analytics, Google Webmaster, browser cookies, third party social media sites
    and other such tools.
    <br />
    <br />
    <b>Jurisdiction : </b>
    Any disputes arising over privacy and website terms of use shall be governed
    by the laws of India.
    <br />
    Our privacy policy might be changed and we will surely notify you of such
    material changes as required by law. Besides this, an updated copy will be
    posted on our website.
  </div>
)

const aboutUs = (
  <div className="about-us-content">
    Writing is a difficult task, but publishing should not be and thus Wisdom
    Words publishing has been initiated with a vision to take off the load from
    the authors and writers that have long been engaged in time-intensive tasks
    like thinking about the content presentation, marketing strategies, and
    reaching out to the right and relevant audience of their content. We
    streamline all their pre-publishing and post -publishing hassle so that they
    can whole-heartily focus on their creative content. We deliver the end to
    end service-driven publishing services via our online publishing platform.
    <br />
    <br />
    Wisdom Word Publishing is one stop for all your publishing needs, be it a
    pre-publishing or post-publishing. We have got you all covered like editing,
    cover designing, page-setting, ISBN, copyright, marketing, distribution and
    so on. Wisdom Words Publishing being one of the growing publishing houses
    holds experienced, young and dedicated professionals who always reciprocate
    their authors with the Value for Money, Reliability, Transparency, Quality
    Assurance, Seamless Communication and Time Commitment.
    <br />
    <br />
    Besides it, nurturing the human relation is also our top-most priority and
    thus our journey with the authors doesn’t end with just delivering the
    published books, but it rather goes beyond it. Our team makes sure that our
    authors never face any issue in after-sales support. Whether it is
    associated with the transparency in sales reports or royalty payments or it
    is about addressing the grievances. The long-term association is our
    priority and we take it way too seriously. We strongly believe that we can
    sustainably grow if our client’s associates are growing.
    <br />
    <br />
    Don’t doubt self-publishing your book. Even renowned authors like Rudyard
    Kipling, Stephen King, Amish, Mark Twain, E.L. James Ernest Hemingway got
    their book self-published. And rest all is history now. We know how
    successful they all are.
    <br />
    <br />
    Don’t hesitate about self-publishing a book, just drop us a query and our
    team will be a big relief for you.
  </div>
)

const extraPageContent = {
  faqs: {
    title: "Faqs",
    content: faqs.map(faq => {
      const { q, a } = faq
      return (
        <>
          {q}
          {a}
        </>
      )
    }),
  },
  privecypolicy: {
    title: "Our Privacy Policy",
    content: [privPolicy],
  },
  about: {
    title: "About Us",
    content: [aboutUs],
  },
}

const sideBar = [
  // {
  //   title: "About Us",
  //   to: "/about-us",
  // },
  {
    title: "Faqs",
    to: "/frequently-asked-questions",
  },
  {
    title: "Privacy Policy",
    to: "/privacy-policy",
  },
  //   {
  //     title: "Faqs",
  //     to: "/frequently-asked-questions",
  //   },
]

const ExtraSection = ({ page, showSidebar = true }) => {
  const pageData = extraPageContent[page]
  const { title, content } = pageData
  return (
    <section className={`section extra-section ${page}`}>
      {showSidebar ? (
        <div className="extra-section-sidebar">
          {sideBar.map(sideLink => {
            const { to, title } = sideLink
            return (
              <AniLink
                cover
                bg="#ffffff"
                direction="right"
                to={to}
                activeClassName="active"
              >
                {title}
              </AniLink>
            )
          })}
        </div>
      ) : null}
      <div className="extra-section-body">
        <SectionHeader
          head={title}
          // extraStyle={{ maxWidth: "700px", marginRight: "auto" }}
        />
        <div className={`content ${page}`}>{[...content]}</div>
      </div>
    </section>
  )
}
export default ExtraSection
